// const backendUrl = 'http://localhost:8001/';
const backendUrl = '/api/';

export function logMessage(level, message) {

    // Create the log entry
    const logEntry = {
        level: level.toUpperCase(),
        message: message,
        timestamp: new Date().toISOString(),
    };
    fetch(`${backendUrl}/log_click/${logEntry.level}/${encodeURIComponent(logEntry.message)}`)
        .catch(error => console.error('Error sending log:', error));
}

export function sendMail(sender, body, name) {
    return fetch(`${backendUrl}/mail/send`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ sender, body, name })
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
        }
        return response.json();
    })
    .catch(error => {
        console.error('Error sending mail:', error);
        throw error;
    });
}

export async function postLike(tipName) {
    try {
        const response = await fetch(`${backendUrl}/tips/like`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ name: tipName }),
        });

        if (!response.ok) {
          throw new Error('Failed to update like');
        }

        const data = await response.json();
        logMessage('info', 'like_tip_' + tipName);
        return data;
    } catch (error) {
        console.error('Error updating like:', error);
        throw error;
    }
}

export async function getLikes() {
    try {
        const response = await fetch(`${backendUrl}/tips/likes`, {
            headers: {
                'Accept': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Check content type
        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
            throw new Error("Response is not JSON");
        }

        const text = await response.text();
        try {
            return JSON.parse(text);
        } catch (e) {
            console.error('Invalid JSON response:', text.substring(0, 100));
            throw new Error('Invalid JSON response');
        }
    } catch (error) {
        console.error('Error getting likes:', error);
        return { likes: {} }; // Return empty likes object on error
    }
}